import { Stack } from '@my/ui'
import { H4 } from 'app/components'
import { OfferGridBlock } from './offer-grid.block'

import { OfferGridList } from './offer-grid-list'

export const OfferGridComponent = (block: OfferGridBlock) => {
  return (
    <Stack gap="$3.5">
      <H4 fow="600">{block.offerGridHeading}</H4>
      <OfferGridList block={block} />
    </Stack>
  )
}
